import { render } from "./projectprogress.vue?vue&type=template&id=7285b308"
import script from "./projectprogress.vue?vue&type=script&lang=js"
export * from "./projectprogress.vue?vue&type=script&lang=js"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__